import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import {Partenaires} from "./Home/Partenaires";
import {RechercheCalendrier} from "./Calendrier/RechercheCalendrier";
import {DetailProspection} from "./Calendrier/DetailProspection";

import CommuneService from "../service/CommuneSevice";
export const Calendrier = ({openDownloadModal}) => {
    const { idCommune } = useParams();

    //trouver la commune
    const[commune, setCommune] = useState([]);
    const[loadingCommune, setLoadingCommune] = useState(1);
    const fetchCommune = async(idCommune) => {
        try{
            const data = await CommuneService.find(idCommune);
            console.log(data);
            setCommune(data);
            setLoadingCommune(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchCommune(idCommune);
    }, [idCommune]);

    return (
        <>
        <Helmet>
            <title>Calendrier de prospection{commune && " de "+commune.nom}</title>
            <meta name="description" content="Découvrez la carte de votre commune avec la localisation des points de prélèvements, les dates et les résultats de prospection" />
        </Helmet>
        <main class="type calendrier-resultats">
            <RechercheCalendrier />
            {commune && <DetailProspection commune={commune} openDownloadModal={openDownloadModal} />}
            <Partenaires/>
        </main>
</>
)
}